const root = document.body;
const label = () => {
  root.querySelectorAll('fieldset.variant-option--buttons').forEach((set) => {
    const legend = set.querySelector('legend');
    const value = set.querySelector('input:checked')?.value;
    if (!legend || !value) return;
    let tag = legend.querySelector('.apts-qa-sel');
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'apts-qa-sel';
      legend.append(tag);
    }
    if (tag.textContent !== value) tag.textContent = value;
  });
};
new MutationObserver(label).observe(root, { childList: true, subtree: true });
root.addEventListener('change', label);
label();
